export const surveysConstants = {
    SURVEYS_REQUEST: 'SURVEYS_REQUEST',
    SURVEYS_SUCCESS: 'SURVEYS_SUCCESS',
    SURVEYS_ERROR: 'SURVEYS_ERROR',
};

export const VIEW_TYPE = {
    EDIT: 0,
    VIEW: 1,
    CREATE: 2,
};

export const Tab = {
    General: 0,
    Questions: 1,
    Customization: 2,
};

export const SystemFieldType = {
    EMAIL: 0,
    PHONE: 1,
    NAME: 2,
    SEX: 3,
    DATE_OF_BIRTH: 4,
};

export const ContactFormPlacement = {
    NEGATIVE_SCREEN: 0,
    MAIN_SCREEN: 1,
};

export const SATISFACTION_THRESHOLD_DISABLED = 1;
export const MAX_AI_REVIEW_TAGS = 15;
export const MAX_REVIEW_TAG_NAME_LENGTH = 50;

export const isSatisfactionThresholdDisabled = threshold => Number(threshold) === SATISFACTION_THRESHOLD_DISABLED;

export const RatingScaleType = {
    FIVE_STAR: 0,
    NPS_SCALE: 1,
};

export const QuestionType = {
    RATING: 'rating',
    SINGLE_CHOICE: 'single_choice',
    YES_NO: 'yes_no',
    MULTI_SELECT: 'multi_select',
    SHORT_ANSWER: 'short_answer',
    PARAGRAPH: 'paragraph',
    DATE: 'date',
    NUMBER: 'number',
};

export const FILTERABLE_TYPES = [
    QuestionType.RATING,
    QuestionType.SINGLE_CHOICE,
    QuestionType.YES_NO,
    QuestionType.MULTI_SELECT,
];

export const isSurveySendable = survey => survey.sendSurveyEnabled !== false;

export const SURVEY_TEXT_LIMITS = {
    title: 60,
    message: 500,
};

export const SURVEY_TEXT_FIELDS = [
    { name: 'title', label: 'common.title', maxLength: SURVEY_TEXT_LIMITS.title },
    {
        name: 'positiveMessage',
        label: 'FeedbackSurveys.positiveMessage',
        maxLength: SURVEY_TEXT_LIMITS.message,
        multiline: true,
    },
    {
        name: 'negativeMessage',
        label: 'FeedbackSurveys.negativeMessage',
        maxLength: SURVEY_TEXT_LIMITS.message,
        multiline: true,
        ratingOnly: true,
    },
];

export const QUESTION_TYPE_OPTIONS = [
    { value: 'rating', label: 'FeedbackSurveys.typeRating' },
    { value: 'single_choice', label: 'FeedbackSurveys.typeSingleChoice' },
    { value: 'yes_no', label: 'FeedbackSurveys.typeYesNo' },
    { value: 'multi_select', label: 'FeedbackSurveys.typeMultiSelect' },
    { value: 'short_answer', label: 'FeedbackSurveys.typeShortAnswer' },
    { value: 'paragraph', label: 'FeedbackSurveys.typeParagraph' },
    { value: 'date', label: 'FeedbackSurveys.typeDate' },
    { value: 'number', label: 'common.number' },
];
